require('./distributeWithKeyDialog.less');


class DistributeWithKeyController {
    activeLine;
    activeYear;
    distributionKeys;
    selectedKey;

    constructor(private $mdDialog, private Prognosis, private toastService, private DistributionKeys){
    }

    $onInit(){
        this.DistributionKeys.getDistributionKeys().$promise.then(
            (result) => {
                this.distributionKeys = result;
            }, (error) => {
                this.toastService.parseError(error);
            }
        )
    };

    save (){
        var valToSend = {articleNo: this.activeLine.articleNo, distributionKeyType: 'STANDARD', forecastTypeId: this.activeLine.id, distributionKeyId: this.selectedKey.key.id, total: this.selectedKey.amount, year: this.activeYear};
        this.Prognosis.distributionKeyForecasts(valToSend).$promise.then(
            (result) => {
                this.activeLine.forecastLine.months = result.months;
                this.hide();
            },
            (error) => {
                this.toastService.parseError(error);
            }
        )
    };

    hide () {
        this.$mdDialog.hide();
    };

    cancel () {
        this.$mdDialog.cancel();
    };

}

class DistributeWithKeyOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "distributeWithKeyDialogController";
    public template: any = require('./distributeWithKeyDialog.html');
    bindings: any = {
        activeLine:'=',
        activeYear:'='
    };

}

rkcApp.controller("distributeWithKeyDialogController", ['$mdDialog', 'Prognosis', 'toastService', 'DistributionKeys', function ($mdDialog, Prognosis, toastService, DistributionKeys) {
    return new DistributeWithKeyController($mdDialog, Prognosis, toastService, DistributionKeys);
}])
    .component("distributeWithKeyDialog", new DistributeWithKeyOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/prognosis/distributeWithKeyDialog/distributeWithKeyDialog.ts
 **/